<app-list
  class="radio-list"
  [scrollable]="!!scrollable"
  [items]="items"
  [keyExpr]="valueExpr"
>
  <ng-template listItem let-item="item" let-index="index">
    <div
      class="radio-item"
      [ngClass]="{
        'state-selected': isSelected(item, index, radioInputEl),
        'state-disabled': !!disabled
      }"
    >
      <div
        class="radio-item-content"
        (click)="onRadioBtnClick($event, item, index, radioInputEl)"
      >
        <input
          #radioInputEl
          type="radio"
          [name]="name"
          [hidden]="true"
          [disabled]="!!disabled"
          [value]="extractValue(item, index)"
        />

        <div class="radio-input-indicator" *ngIf="!!showRadioButton">
          <div class="radio-input-indicator-content">
            <div class="radio-input-indicator-marker"></div>
          </div>
        </div>

        <ng-template
          [ngTemplateOutlet]="itemTplRef?.templateRef ?? radioContentTpl"
          [ngTemplateOutletContext]="{item, label: extractDisplay(item, index)}"
        ></ng-template>
      </div>
    </div>
  </ng-template>
</app-list>

<ng-template #radioContentTpl let-item="item" let-label="label">
  <div class="radio-content" *ngIf="!!((showIcon && item.icon) || label)">
    <app-iconic
      class="icon"
      *ngIf="showIcon && !!item.icon"
      [icon]="item.icon"
      [useAs]="item.iconAs"
    ></app-iconic>

    <div class="label" *ngIf="!!label">
      {{ label }}
    </div>
  </div>
</ng-template>
